import React from 'react';
import { FaInstagram, FaTwitter, FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import footerImg from '../Assets/Banner/Groot.png';

const Footer = () => {
  const styles = {
    footer: {
      backgroundColor: '#1c2544',
      color: '#fff',
      padding: '60px 40px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      rowGap: '30px',
      fontFamily: 'sans-serif',
    },
    leftCol: {
      flex: '1 1 300px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '20px',
    },
    footerImg: {
      width: 130,
      height: 'auto',
      borderRadius: 8,
    },
    leftText: {
      fontSize: 18,
      lineHeight: 1.6,
      maxWidth: 200,
    },
    smile: {
      fontSize: 22,
      marginLeft: 4,
    },
    midCol: {
      flex: '1 1 300px',
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(120px, 1fr))',
      gap: '16px 40px',
    },
    link: {
      fontSize: 18,
      fontWeight: 600,
      color: '#fff',
      textDecoration: 'none',
    },
    rightCol: {
      flex: '1 1 120px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '16px',
    },
    icon: {
      color: '#fff',
      fontSize: 22,
      cursor: 'pointer',
    },
    bottomText: {
      width: '100%',
      fontSize: 14,
      lineHeight: 1.6,
      textAlign: 'center',
      marginTop: 40,
    },
  };

  return (
    <>
      {/* Responsive Media Queries */}
      <style>{`
        @media (max-width: 768px) {
          .footer {
            flex-direction: column;
            align-items: center;
            padding: 40px 20px;
          }

          .left-col,
          .mid-col,
          .right-col {
            flex: 1 1 100% !important;
            align-items: center !important;
            text-align: center;
          }

          .left-col {
            flex-direction: column !important;
            gap: 10px !important;
          }

          .left-text {
            max-width: none !important;
          }

          .footer-img {
            margin: 0 auto !important;
          }

          .right-col {
            display: flex !important;
            flex-direction: row !important;
            justify-content: center !important;
            align-items: center !important;
            gap: 20px !important;
            width: 100% !important;
          }
        }
      `}</style>

      <footer className="footer" style={styles.footer}>
        {/* Left Column */}
        <div className="left-col" style={styles.leftCol}>
          <img src={footerImg} alt="Say Hi" className="footer-img" style={styles.footerImg} />
          <div className="left-text" style={styles.leftText}>
            You scrolled all the way down... and Groot notice He said: “I am Groot.” Which obviously means Congrats on reaching the end — you're now part of the Glowingrowth galaxy!

            <span style={styles.smile}> 😊</span>
          </div>
        </div>

        {/* Middle Column */}
        <div className="mid-col" style={styles.midCol}>
          {[
            'About Us',
            'Services',
            'Vision',
            'Portfolio',
            'clients',
            'Blog',
            'Contact Us',
            'Privacy Policy',
          ].map((label) => (
            <a key={label} href="#" style={styles.link}>
              {label}
            </a>
          ))}
        </div>

        {/* Right Column - Social Icons */}
        <div className="right-col" style={styles.rightCol}>
          <FaInstagram style={styles.icon} />
          <FaTwitter style={styles.icon} />
          <FaFacebookF style={styles.icon} />
          <FaLinkedinIn style={styles.icon} />
        </div>
      </footer>
    </>
  );
};

export default Footer;
